import { render, staticRenderFns } from "./MainRightBet.vue?vue&type=template&id=64fce51e&scoped=true&"
import script from "./MainRightBet.vue?vue&type=script&lang=js&"
export * from "./MainRightBet.vue?vue&type=script&lang=js&"
import style0 from "./MainRightBet.vue?vue&type=style&index=0&id=64fce51e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fce51e",
  null
  
)

export default component.exports